import { useEffect, useRef, useState } from "react";
import { Timer, X } from "lucide-react";

const DEFAULT_SECONDS = 15 * 60;

/**
 * Small workshop timer that students can manually start when they begin Step 1.
 * Calm visual — pulses in the final minute. Stays in the wizard top bar.
 */
export default function WorkshopTimer() {
  const [seconds, setSeconds] = useState(DEFAULT_SECONDS);
  const [running, setRunning] = useState(false);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!running) return;
    intervalRef.current = setInterval(() => {
      setSeconds((s) => {
        if (s <= 1) {
          clearInterval(intervalRef.current);
          setRunning(false);
          return 0;
        }
        return s - 1;
      });
    }, 1000);
    return () => clearInterval(intervalRef.current);
  }, [running]);

  const start = () => {
    if (seconds === 0) setSeconds(DEFAULT_SECONDS);
    setRunning(true);
  };

  const stop = () => {
    setRunning(false);
    setSeconds(DEFAULT_SECONDS);
  };

  const mm = String(Math.floor(seconds / 60)).padStart(2, "0");
  const ss = String(seconds % 60).padStart(2, "0");
  const isWarning = running && seconds <= 60;
  const isDone = !running && seconds === 0;

  if (!running && seconds === DEFAULT_SECONDS) {
    return (
      <button
        type="button"
        onClick={start}
        className="weave-timer-start"
        data-testid="timer-start-btn"
        title="Start a calm 15-minute timer"
      >
        <Timer size={14} />
        <span>Start 15-min timer</span>
      </button>
    );
  }

  return (
    <div
      className={`weave-timer-pill ${isWarning ? "is-warning" : ""} ${
        isDone ? "is-done" : ""
      }`}
      data-testid="timer-pill"
      role="timer"
      aria-live="polite"
    >
      <Timer size={14} />
      <span className="weave-timer-time">
        {isDone ? "Time's up — take a breath" : `${mm}:${ss}`}
      </span>
      <button
        type="button"
        onClick={stop}
        className="weave-timer-stop"
        aria-label="Stop timer"
        data-testid="timer-stop-btn"
      >
        <X size={12} />
      </button>
    </div>
  );
}
